import { columns } from "@/mocks/columns";
import SectionHeader from "@/components/base/SectionHeader";

export default function Columns() {
  return (
    <section id="columns" className="w-full bg-background-100/60 px-4 py-14 md:px-6 md:py-20">
      <div className="mx-auto flex w-full max-w-7xl flex-col gap-8">
        <SectionHeader
          eyebrow="深度吃瓜"
          title="不止于看，更懂门道"
          subtitle="每期专题从现象切入、层层拆解，带你看懂吃瓜背后的行业逻辑与内容规律。"
        />

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {columns.map((col) => (
            <article
              key={col.id}
              className="group relative overflow-hidden rounded-2xl bg-foreground-950 transition-transform duration-300 hover:-translate-y-1"
            >
              <a href="#library" className="block aspect-[4/5] w-full overflow-hidden bg-background-200">
                <img
                  src={col.cover}
                  alt={col.title}
                  title={`${col.title} - 吃瓜视频在线深度专题`}
                  className="h-full w-full object-cover opacity-90 transition-transform duration-500 group-hover:scale-105"
                />
              </a>
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/95 via-foreground-950/40 to-foreground-950/10" />
              <div className="absolute inset-x-0 bottom-0 flex flex-col gap-3 p-5">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="flex items-center gap-1 rounded-full bg-accent-500 px-2.5 py-1 text-xs font-bold text-background-50">
                    <i className="ri-quill-pen-line text-[12px]" />
                    {col.badge}
                  </span>
                  <span className="flex items-center gap-1 text-xs text-background-200">
                    <i className="ri-time-line" />
                    {col.minutes}
                  </span>
                </div>
                <h3 className="font-heading text-lg leading-snug text-background-50">
                  <a href="#library" className="transition-colors hover:text-accent-300">
                    {col.title}
                  </a>
                </h3>
                <p className="text-sm leading-relaxed text-background-100/90">{col.excerpt}</p>
                <div className="flex items-center justify-between border-t border-background-50/15 pt-3 text-xs text-background-200">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line" />
                    {col.views} 次阅读
                  </span>
                  <span className="flex items-center gap-1 font-bold text-accent-300">
                    阅读全文
                    <i className="ri-arrow-right-line" />
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}